import { render, staticRenderFns } from "./BillOfLading.vue?vue&type=template&id=2d75ea5c&scoped=true"
import script from "./BillOfLading.vue?vue&type=script&lang=ts"
export * from "./BillOfLading.vue?vue&type=script&lang=ts"
import style0 from "./BillOfLading.vue?vue&type=style&index=0&id=2d75ea5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d75ea5c",
  null
  
)

export default component.exports